import './chunk-5160dcda.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { D as Dropdown, a as DropdownItem } from './chunk-e8a31b14.js';
export { D as Dropdown, a as DropdownItem } from './chunk-e8a31b14.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Dropdown);
    registerComponent(Vue, DropdownItem);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/dropdown.js
// module id = 231
// module chunks = 0